import { motion } from "framer-motion";
import TypedText from "./HeroSubtitle";
import { useSelector } from "react-redux";

export default function Hero() {
  const { loading, error, data } = useSelector((state) => state.portfolio);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  return (
    <section
      id="home"
      className="relative flex flex-col-reverse md:flex-row items-center min-h-screen px-6 md:px-20 py-16 bg-gradient-to-br from-indigo-600 via-purple-700 to-pink-600 dark:from-gray-900 dark:via-gray-800 dark:to-gray-950 overflow-hidden"
    >
      {/* Left Column: Text Content */}
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full md:w-1/2 text-center md:text-left text-white"
      >
        <h1 className="text-5xl md:text-7xl font-extrabold font-heading mb-5 drop-shadow-lg tracking-tight leading-tight">
          {data.hi_my_name}
        </h1>
        <div className="text-xl md:text-2xl font-semibold mb-8 drop-shadow-md max-w-lg mx-auto md:mx-0">
          <TypedText titles={data.typerText} />
        </div>
        <div className="flex flex-col md:flex-row gap-4 justify-center md:justify-start">
          <a
            href="#contact"
            className="inline-block px-8 py-4 bg-white text-indigo-700 font-bold rounded-lg shadow-lg hover:bg-indigo-600 hover:text-white transition-colors duration-300"
          >
            Hire Me
          </a>
          <a
            href={data.resumeUrl || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-indigo-700 transition-colors duration-300"
          >
            Download CV
          </a>
        </div>
      </motion.div>

      {/* Right Column: Hero Image */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full md:w-1/2 mb-16 md:mb-0 flex justify-center"
      >
        <img
          src={data.heroImage || "/assets/hero-image.png"}
          alt="Hero Illustration"
          className="max-w-full h-auto rounded-3xl shadow-2xl"
        />
      </motion.div>

      {/* Decorative SVG wave */}
      <svg
        className="absolute bottom-0 left-0 w-full"
        height="160"
        viewBox="0 0 1440 160"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0,96L60,106.7C120,117,240,139,360,160C480,181,600,203,720,197.3C840,192,960,160,1080,160C1200,160,1320,192,1380,208L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          className="fill-white dark:fill-gray-900"
        />
      </svg>
    </section>
  );
}
